





exports.default =
  props:
    item: { required: true }
    searchText: { required: true }

  methods:
    replacer: (match) ->
      '<strong>'+match+'</strong>'


  computed:
    text: ->
      @item?.name?.replace(new RegExp(@searchText, "i"), @replacer)





// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/autocomplete/item.vue